export default __webpack_public_path__ + "static/media/three_of_wands.0a044408.png";